import emailjs from '@emailjs/browser';

export const sendEmail = (e, data, templateID) => {
    emailjs.sendForm(process.env.REACT_APP_EMAIL_SERVICE_ID || "service_9sbma8h", templateID, data, process.env.REACT_APP_EMAIL_PUBLIC_KEY || "YX6Ix4FNwXw3hRdaD")
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
};